import React from "react";

export enum FixedPanelFixTo {
  TOP = "top",
}

export enum FixedPanelBreakpoint {
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
  XLARGE = "xl",
}

export interface FixedPanelProps {
  /** Main content to display inside the Panel */
  children: React.ReactNode;

  /** Any extra CSS classes for the component */
  className?: string;

  /** Applies the `spark-panel--condensed` class once the scroll position exceeds the height of the Header and Panel. This class can then be used to add additional condensed styling to the contents of the Fixed Panel e.g. reducing font-sizes, margins or padding. */
  condenseOnScroll?: boolean;

  /** Sets the breakpoint at which the Fixed Panel behavior starts at. Options are `SMALL, MEDIUM, LARGE, XLARGE`. If not set the panel will dock at all breakpoints. */
  dockingBreakPoint?: FixedPanelBreakpoint | "sm" | "md" | "lg" | "xl";

  /** Position to affix panel to viewport. Currently, only `TOP` is available. If the panel is a child of the header this does not need to be set */
  fixTo?: FixedPanelFixTo | "top";

  /** An element ref used if it is not a Spark Header. If using a Spark Header, this does not need to be supplied. */
  headerEl?: React.ReactNode | React.MutableRefObject<JSX.Element | null>;

  /** An element ref used to determine the scroll position when the Fixed Panel should hide. If not set the panel will show at all times. */
  hideAtEl?: React.ReactNode | React.MutableRefObject<JSX.Element | null>;

  /** Hides the Fixed Panel when a user scrolls. */
  hideOnScroll?: boolean;

  /** id for Fixed Panel */
  id?: string;
}
